import { createPortal } from 'react-dom';
import styled from 'styled-components';

export const BackdropArea = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  z-index: 1000;
`;

const Backdrop = ({ onClick }) => {
  return createPortal(<BackdropArea onClick={onClick} />, document.getElementById('backdrop'));
};

export default Backdrop;